// extracted by mini-css-extract-plugin
export default {"button":"fB_dS","isActive":"fB_f2","focus-visible":"fB_gY","focusVisible":"fB_gY","isNotInverted":"fB_n7","isFocused":"fB_nV","icon":"fB_hj","tooltip":"fB_n2"};